define([
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/def/Request",
	"./util",
	"./TriggerExportManuallyToolbarPlugin"
], function(lang,Action,ActionFactory,Request,util,TriggerExportManuallyToolbarPlugin) {

	return ActionFactory.declare("TriggerExportManually", Action, {
		constructor: function(def) {
			this.classController = "Export.TriggerExportManually";
			this.classToolbarPlugin = TriggerExportManuallyToolbarPlugin;
			this.m_request = lang.mixin(new Request(),{
				m_module: "Export",
				m_operation:"ExportNode"
			});
		},

		hasAccess: function(/*csi.def.Context*/ctx) {
			var result = this.inherited(arguments);

			if (result) {
				result = util.isCurrentUserAllowedToExport();
			}

			// show the action only if there are export batches available for this type
			if (result) {
				var node = ctx.getNode();
				var batches = util.getManuallyTriggeredBatchesForType(node.$Type,ctx.cache);
				result = batches && batches.length > 0;
			}
			return result;
		}
	});
});